export enum SupportHubEndpoints {
    SSO = '/v1/sso/zendesk',
    LIVE_CHAT = '/v1/sso/zendesk-widget',
}
